import { RadioOption } from '@Types/Form.types';
import { Radio } from '@kg-internal/pv3-uikit';
import styles from './RadioList.module.scss';

type Props = {
  radioOptions: RadioOption[];
  title: string;
  handleOnClick: (value: string | number | undefined) => void;
  radioName: string;
  currentValue: string | number | undefined;
};

const FilterList = ({ radioOptions, title, handleOnClick, radioName, currentValue }: Props) => {
  const block = 'radio-list';

  return (
    <div className={`content-top ${styles[`${block}__option-list`]}`}>
      <h3 className={`${styles[`${block}__title`]}`}>{title}</h3>

      <div className={`${styles[`${block}__container`]}`}>
        {radioOptions.map((radio) => (
          <Radio
            key={radio.key}
            label={radio.label}
            name={radioName}
            value={radio.key}
            isSelected={radio.key === currentValue}
            // @ts-expect-error The onclick works but TS doesn't recognize it
            onClick={(e) => {
              if (isNaN(e.target.value)) {
                handleOnClick(e.target.value !== currentValue ? e.target.value : undefined);
              } else {
                handleOnClick(+e.target.value !== currentValue ? +e.target.value : undefined);
              }
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default FilterList;
